module.exports = __webpack_public_path__ + "static/media/cross.15521e18.svg";